import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ProvideAuth } from '@/common/hooks/useAuth';
import Routes from '@/common/routes/Routes';
import { SnackbarProvider } from 'notistack';
import { RecoilRoot } from 'recoil';

function App() {
  const router = createBrowserRouter(Routes);
  return (
    <React.StrictMode>
      <ProvideAuth>
        <RecoilRoot>
          <SnackbarProvider maxSnack={3} variant={'error'} anchorOrigin={{ horizontal: 'center', vertical: 'top' }}>
            <RouterProvider router={router} />
          </SnackbarProvider>
        </RecoilRoot>
      </ProvideAuth>
    </React.StrictMode>
  );
}

export default App;
